module.exports = __webpack_public_path__ + "static/media/mypic.461e70bf.jpeg";